import packageJson from '../../package.json';

export const packageVersion = packageJson.version;
